const styleOverrides = {
  root: ({
    theme
  }) => ({
    fontSize: theme.typography.h6.fontSize,
    fontWeight: 'bold'
  })
};
export default {
  styleOverrides
};
//# sourceMappingURL=MuiAlertTitle.js.map